import React from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Grid, Row, Col, Text } from 'shared/components'

import * as styles from './styles'

const UpdateButtonComponent = ({ value: event, onRouteToUpdateEditForm }) => (
  <Grid>
    <Row center="xs">
      <Col xs={12}>
        <Button
          circle
          small
          outlined
          disabled={event.resolved}
          onClick={onRouteToUpdateEditForm}
        >
          <FontAwesomeIcon size="lg" icon="pencil-alt" css={styles.icon} />
          <Text size={11}>Update</Text>
        </Button>
      </Col>
    </Row>
  </Grid>
)

UpdateButtonComponent.propTypes = {
  value: PropTypes.shape(),
  onRouteToUpdateEditForm: PropTypes.func,
}

export default UpdateButtonComponent
